
export default {
  page: {
    background: '#484848',
    color: '#2c3035'
  },
  main: {
    color: '#2c3035',
  },
  link: {
    color: '#2c3035',
    textDecoration: 'underline'
  },
  estimatedDeliveryDateOrStatus: {
    textTransform: 'uppercase',
    fontFamily: 'Oswald, sans-serif',
    fontWeight: '500',
    fontSize: '40px',
    lineHeight: '40px'
  },
  signatureRequired: {
    background: '#fa965a',
    color: '#222222'
  },
  auctaneBrand: {
    color: '#555555',
    filter: 'invert(1) grayscale(1)',
    textDecoration: 'none'
  },
  custom1: {  // layout01 card
  },
  custom2: {  // layout01 card header
    background: '#222222',
    color: 'white'
  }
};